export const endpoints = {
  amp: {
    published: () => ({
      url: `/published/domain`,
    }),
    publishedById: (id) => ({
      url: `/published/${id}`,
    }),
  },
  crm: {
    accountInfo: (id) => ({
      url: `/organization/connector/crm/accountInfo?accountIdentifier=${id}`,
    }),
  },

  plugin: {
    execute: (id) => ({
      url: `/plugin/${id}/execute`,
    }),
  },

  realtime: {
    requestToken: () => ({
      url: `/realtime/requestToken/domain`,
    }),
  },
};
